import { FormComponentWrapper } from 'components/FormComponentWrapper';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { InternalFormDatepicker } from './InternalFormDatepicker';
import type { FormDatepickerProps } from './types';

export const FormDatepicker = <T extends FieldValues = FieldValues>({
  description,
  label,
  wrapperClassname = '',
  name,
  control,
  mode,
  disabled,
  message,
  rules,
  ...dateHookProps
}: FormDatepickerProps<T>) => {
  return (
    <Controller
      name={name}
      {...(control
        ? { control }
        : {
            // if undefined, Controller reads from FormProvider
          })}
      rules={rules}
      render={({
        field: { onBlur, onChange, value },
        fieldState: { error },
      }) => (
        <FormComponentWrapper
          name={name}
          description={description}
          error={error}
          label={label}
          className={wrapperClassname}
          message={message}
          disabled={disabled}
        >
          <InternalFormDatepicker
            {...dateHookProps}
            disabled={disabled}
            mode={mode}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
          />
        </FormComponentWrapper>
      )}
    />
  );
};
